import React from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';

import PageNotFound from '../components/Common/NotFound404';
import ProtectedRoutes from './ProtectedRoutes';
import Launcher from '../views/Launcher/Launcher';
import NimbusLoginPage from '../views/Login/NimbusLoginPage';
import VaultLoginPage from '../views/Login/VaultLoginPage';
import AdminPanelLoginPage from '../views/Login/AdminPanelLoginPage';
import ResetPassword from '../views/Login/ResetPassword';
import ClearCacheLogout from './views/ClearCacheLogout/ClearCacheLogout';

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <React.Suspense fallback={<h5>Loading....</h5>}>
        <Routes>
          <Route path="/login" element={<AdminPanelLoginPage />} />
          <Route path="/reset" element={<PageNotFound />} />
          <Route path="/launcher" element={<Launcher />} />
          <Route path="/product-login-nimbus" element={<NimbusLoginPage />} />
          <Route path="/product-login-vault" element={<VaultLoginPage />} />
          <Route path="/clear-client-storage" element={<ClearCacheLogout />} />
          <Route
            path="/reset-password/:uid/:token/"
            element={<AdminPanelLoginPage />}
          />
          <Route
            path="/reset-password/:uid/:token/:tenant/:product"
            element={<ResetPassword />}
          />

          {/* 🔒 Protected Routes */}
          <Route path="/*" element={<ProtectedRoutes />} />

          {/* 404 fallback */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
};

export default AppRoutes;
